import {LocationPoint} from '@/common/interfaces/location';
import {createAsyncThunk} from '@/app/store/createAsyncThunk';

/**
 * Determines general (approximate) user's device settlement. Server side use the client IP value to determine it.
 */
export const determinateGeneralSettlement = createAsyncThunk<
	{
		language: string;
	},
	{location: LocationPoint},
	void
>('geolocation/determinateGeneralSettlement', async ({language}, {context, success}) => {
	const result = await context.backendAPI.location.determine(undefined, language);
	return success(result);
});
